import React, { useEffect, useState } from "react";
import { Bell, BellOff } from "lucide-react";
import { toast } from "sonner";
import { isPushSupported, getSubscribed, subscribePush, unsubscribePush } from "@/lib/push";

export const PushToggle = () => {
  const [supported, setSupported] = useState(false);
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    (async () => {
      if (await isPushSupported()) {
        setSupported(true);
        setOn(await getSubscribed());
      }
    })();
  }, []);

  if (!supported) return null;

  const toggle = async () => {
    setBusy(true);
    try {
      if (on) {
        await unsubscribePush();
        setOn(false);
        toast.success("Notifications push désactivées");
      } else {
        const perm = await Notification.requestPermission();
        if (perm !== "granted") { toast.error("Autorisation des notifications refusée"); return; }
        await subscribePush();
        setOn(true);
        toast.success("Notifications push activées");
      }
    } catch (e) {
      toast.error("Action impossible pour le moment");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={toggle}
      disabled={busy}
      title={on ? "Désactiver les notifications push" : "Activer les notifications push"}
      className={`flex h-10 w-10 items-center justify-center rounded-lg border transition-colors ${on ? "border-gold bg-gold/10 text-gold" : "border-navy/10 text-navy hover:bg-navy/5"}`}
      data-testid="push-toggle"
    >
      {on ? <Bell className="h-5 w-5" /> : <BellOff className="h-5 w-5" />}
    </button>
  );
};
